import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Spring/PlaceValueWithin50/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValueWithin50',
  field: 'Number',
  weeks: [7, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/1CountFrom20To50" */ './1CountFrom20To50'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/2TwentyThirtyFortyAndFifty" */ './2TwentyThirtyFortyAndFifty'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/3CountByMakingGroupsOfTens" */ './3CountByMakingGroupsOfTens'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/4GroupsOfTensAndOnes" */ './4GroupsOfTensAndOnes'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/5PartitionIntoTensAndOnes" */ './5PartitionIntoTensAndOnes'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/6TheNumberLineTo50" */ './6TheNumberLineTo50'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/7EstimateOnANumberLineTo50" */ './7EstimateOnANumberLineTo50'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin50/8OneMoreOneLess" */ './8OneMoreOneLess'
        )
    })
  ]
});
export default Block;
